import styled from '@emotion/styled';

const InteractiveCoverImageStyle = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
`;

export default InteractiveCoverImageStyle;
